import React from "react";
import { Helmet } from "react-helmet-async";
import { useStore } from "../context/StoreContext";
import "./Legal.css";

export default function PrivacyPolicy() {
  const { navigate } = useStore();

  return (
    <div className="legal-page">
      <Helmet>
        <title>Privacy Policy — City Shopping Center & Dulha House</title>
        <meta name="description" content="Privacy Policy for City Shopping Center & Dulha House, including our use of Google AdSense, cookies, Firebase, and WhatsApp." />
        <link rel="canonical" href="https://cityshopingcenter.com/privacy-policy" />
      </Helmet>

      <div className="page-header" data-echo="PRIVACY">
        <h1>PRIVACY POLICY</h1>
        <p>Last updated: 12 July 2026</p>
      </div>

      <div className="legal-wrap">
        <p>
          City Shopping Center &amp; Dulha House ("we", "our", "us") operates the website
          cityshopingcenter.com (the "Site"). This Privacy Policy explains what information we
          collect, how we use it, and the choices you have. By using the Site, you agree to the
          practices described here.
        </p>

        <h2>1. Information We Collect</h2>
        <p><strong>Information you provide directly.</strong> When you create an account, we collect
        your name, email address, and a password. When you place an order, we record the items
        ordered, the total amount, and your account details so we can process and track your order.
        When you contact us through our contact form or WhatsApp, we receive the name, phone number,
        and message details you choose to send.</p>
        <p><strong>Information collected automatically.</strong> Like most websites, we and our
        service providers may automatically collect technical information such as your IP address,
        browser type, device type, pages visited, and the date and time of your visit. This is
        collected through cookies and similar technologies (described below) and through analytics
        services.</p>

        <h2>2. How We Use Your Information</h2>
        <p>We use the information we collect to: create and manage your account; process and follow
        up on your orders; respond to your questions and messages; improve our website, products,
        and services; understand how visitors use the Site; and comply with legal obligations.</p>
        <p>We do <strong>not</strong> sell your personal information to anyone.</p>

        <h2>3. Cookies</h2>
        <p>Cookies are small text files stored on your device by your browser. We use cookies and
        similar technologies to keep you signed in, remember your preferences, measure site traffic,
        and (if advertising is enabled) show relevant advertisements. You can control or delete
        cookies through your browser settings. Disabling cookies may affect some features of the
        Site, such as staying logged in.</p>

        <h2>4. Advertising (Google AdSense)</h2>
        <p>We may display advertisements on this Site served by Google AdSense. Google, as a
        third-party vendor, uses cookies — including the DoubleClick cookie — to serve ads to our
        visitors based on their visits to this Site and other sites on the internet.</p>
        <p>Google's use of advertising cookies enables it and its partners to serve ads based on
        your browsing. You may opt out of personalized advertising by visiting Google's Ads
        Settings page at <span className="legal-url">www.google.com/settings/ads</span>, or opt out
        of some third-party vendors' use of cookies at{" "}
        <span className="legal-url">www.aboutads.info/choices</span>. For more information about how
        Google uses data when you use our Site, see{" "}
        <span className="legal-url">policies.google.com/technologies/partner-sites</span>.</p>

        <h2>5. Third-Party Services We Use</h2>
        <p>We rely on trusted third-party services to run this Site. These providers process limited
        data on our behalf:</p>
        <p><strong>Firebase (Google):</strong> account authentication, order storage, and site
        analytics. <strong>Cloudinary:</strong> hosting of product images. <strong>WhatsApp
        (Meta):</strong> when you choose to place an order or contact us via WhatsApp, your
        communication is handled through WhatsApp and governed by WhatsApp's own privacy policy.
        Each of these providers has its own privacy policy governing the data it processes.</p>

        <h2>6. Data Retention &amp; Security</h2>
        <p>We keep your account and order information for as long as your account is active or as
        needed to provide our services and meet legal requirements. We use reasonable technical
        measures — including secure (HTTPS) connections and access controls — to protect your
        information. However, no method of transmission over the internet is 100% secure, and we
        cannot guarantee absolute security.</p>

        <h2>7. Your Rights &amp; Choices</h2>
        <p>You may access and update your account information at any time from your account page.
        You may request deletion of your account and associated personal data by contacting us using
        the details below, and we will act on your request within a reasonable time unless we are
        required to retain certain records by law.</p>

        <h2>8. Children's Privacy</h2>
        <p>This Site is a general-audience shopping website and is not directed at children under
        13. We do not knowingly collect personal information from children under 13. If you believe
        a child has provided us personal information, please contact us and we will delete it.</p>

        <h2>9. Changes to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. Any changes will be posted on this
        page with an updated "Last updated" date. Continued use of the Site after changes means you
        accept the updated policy.</p>

        <h2>10. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy or your data, you can reach us at:</p>
        <p>
          City Shopping Center &amp; Dulha House<br />
          Shop# 23, Touseef Market, Daska, Pakistan<br />
          Email: cityshoppingcenter.pk@gmail.com<br />
          Or via WhatsApp through the button on our{" "}
          <button className="legal-inline-link" onClick={() => navigate("contact")}>Contact page</button>.
        </p>
      </div>
    </div>
  );
}
